$(document).ready(function(){

	$('.s3-vdo-row').slick({
		slidesToShow:4,
		slidesToScroll: 1,
		arrows: true,
		fade: false,
		autoplay: false,
		dots: false,
		variableWidth:true,
		centerMode: false,
		infinite:true,
		responsive: [
			{
				breakpoint: 1021,
				settings:{slidesToShow:3, slidesToScroll: 1, variableWidth:false,}
			},
			{
				breakpoint: 767,
				settings: {slidesToShow:3,centerMode: true, variableWidth:true, dots:false,}
				
			}
		]
	});
	
	
	$('.s3-viral-row').slick({
		slidesToShow:4,
		slidesToScroll: 1,
		arrows: false,
		fade: false,
		autoplay: false,
		dots: false,
		variableWidth:false,
		centerMode: false,
		infinite:true,
		responsive: [
			{
				breakpoint: 1620,
				settings:{slidesToShow:3, slidesToScroll: 1,}
			},
			{
				breakpoint: 1220,
				settings:{slidesToShow:2, slidesToScroll: 1,}
			},
			
			{
				breakpoint: 767,
				settings: {slidesToShow:1, slidesToScroll: 1, variableWidth:true,centerMode: true,}
				
			}
		]
	});
	
	
	$('.s5-left-inner').slick({
		slidesToShow:1,
		slidesToScroll: 1,
		arrows: false,
		fade: false,
		autoplay: false,
		dots: true,
		variableWidth:false,
		centerMode: false,
		responsive: [
			{
				breakpoint: 1021,
				settings:{slidesToShow:1, slidesToScroll: 1, }
			},
			{
				breakpoint: 767,
				settings: {slidesToShow:1, slidesToScroll: 1,}
				
			}
		]
	});
	
	
	$('.review-row').slick({
		slidesToShow:3,
		slidesToScroll: 1,
		arrows: false,
		fade: false,
		autoplay: false,
		dots: false,
		variableWidth:false,
		centerMode: false,
		responsive: [
			{
				breakpoint: 1021,
				settings:{slidesToShow:2, slidesToScroll: 1,dots: true,}
			},
			{
				breakpoint: 767,
				settings: {slidesToShow:1, slidesToScroll: 1,variableWidth:false, dots: true}
				
			}
		]
	});
	
	
	
	//SELECT COLOR
	$('.color-tog').click(function(e) {
		$('.color-drower').slideUp();
		if ( $(this).next('.color-drower').is(':visible')){
			$(this).next('.color-drower').slideUp();
		}else{
			$(this).next('.color-drower').slideDown();
		}
		
		 event.stopPropagation();
	});
	
	$(document).click(function(e) {
        $('.color-drower').slideUp();
    });
	
	
	$('.colorname-list li').click(function(e) {
		$(this).closest('.color-drower').slideUp();
		$(this).closest('.selct-colorbx').find('.color-tog').html($(this).html());
		var colorVarid = $(this).closest('.selct-colorbx').find('.color-tog .c-swatch').attr('data-color');
		var colorImage = $(this).closest('.selct-colorbx').find('.color-tog .c-swatch').attr('data-img');
		var colorBox = $(this).closest('.selct-colorbx').find('.color-tog .c-swatch').attr('data-box');
		
		// console.log('AA: ', colorImage)
		// console.log('BB: ', colorVarid)
		// console.log('CC: ', colorBox)

		$(this).closest('.package-col').find('.package-top .pckg-prod-box .c-pack-prod-img.prd-img'+colorBox ).attr('src',colorImage);
	});
	
	
	
	$('.add').click(function () {
		$(this).prev().val(+$(this).prev().val() + 1);
	});
	
	$('.sub').click(function () {
		if ($(this).next().val() > 1) {
		if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
		}
	});
	
	
	//accordion
	$(".acdn-heading").click(function() {
		
		var questionDiv = $(this);
		var answerDiv   = $(this).next('.acdn-content');
		var idx = $('.acdn-content').index(answerDiv);
		
		$('.acdn-content').each(function(index, ansDiv) {
            if(index != idx && $(ansDiv).is(':visible')) {
				$(ansDiv).slideUp(500, function() {
					$(ansDiv).prev('.acdn-heading').removeClass('accordion-open');
				});
			}
        });
					
		if (answerDiv.is(':visible')) {
			answerDiv.stop().slideUp(500, function() {
				questionDiv.removeClass('accordion-open');
			});
		} else {
		  questionDiv.addClass('accordion-open');
		  answerDiv.stop().slideDown(500);
		}
	});
	
	

	$(".btn_scorall").click(function() {
		$('html, body').animate({
			scrollTop: $("#select_pkg").offset().top - 50
		}, 2000);
	});
	
	$('ul.topMenu li a').click(function(event) {
		event.preventDefault();
		var ids = $(this).attr('href');
		 $('html, body').animate({
			scrollTop: $(ids).offset().top - 50
		}, 2000);
	});
	
	
	//video
	var video = $('#myVdo video')[0];
	
	$('.ugc1').click(function(e) {
		$('.ugc-modal').addClass('active');
		$('.video-container').show();
		
		var videoFile = $(this).attr('data-vdo');
		video.src = videoFile;
		video.load();
		video.play();
    });	
	
	$('.ugc-close, .ugc-modal').click(function(e) {
		video.src = '';
       	$('.ugc-modal').removeClass('active');
	   	$('.video-container').hide();
    });
	


});



$(document).scroll(function() {
		
	if ($(this).scrollTop() > 110){
		$('.top-fix-bar').addClass('fixed-nav');
	}else{
		$('.top-fix-bar').removeClass('fixed-nav');
	}

});





document.addEventListener("DOMContentLoaded", function () {
    let currentPlaying = null; // Track the currently playing video

    // Click on image or play button to play video
    document.addEventListener("click", function (event) {
        let imgBox = event.target.closest(".s3-vdo-col-img-box");

        if (imgBox) {
            let container = imgBox.closest(".s3-vdo-col");
            let video = container.querySelector("video");

            // If another video is playing, pause it
            if (currentPlaying && currentPlaying !== video) {
                currentPlaying.pause();
                let prevContainer = currentPlaying.closest(".s3-vdo-col");
                prevContainer.querySelector(".s3-vdo-col-img-box").style.display = "block";
                currentPlaying.style.display = "none";
            }

            // Hide image & play video
            imgBox.style.display = "none";
            video.style.display = "block";
            video.play();

            currentPlaying = video;
        }
    });


    // When the video ends, show the image again
    document.addEventListener("ended", function (event) {
        let video = event.target;
        let container = video.closest(".s3-vdo-col");
        let imgBox = container.querySelector(".s3-vdo-col-img-box");

        imgBox.style.display = "block";
        video.style.display = "none";
        video.currentTime = 0;
        video.pause();

        currentPlaying = null;
    }, true);
});